import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function SimulationPreviewScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentCup, targetCup, lift, implantShape, photoURL } = location.state || {};

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial' }}>
      <h2>Your Simulated Preview</h2>
      <p>Based on the options you selected, here's your estimated outcome:</p>

      <div style={{ display: 'flex', gap: '2rem', margin: '2rem 0' }}>
        <div>
          <h4>Before</h4>
          {photoURL ? (
            <img src={photoURL} alt="Before" width="200" />
          ) : (
            <div style={{ width: '200px', height: '250px', background: '#eee', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              No image
            </div>
          )}
        </div>

        <div>
          <h4>After (Simulated)</h4>
          <img
            src="https://via.placeholder.com/200x250.png?text=Simulated+After"
            alt="After"
            width="200"
          />
        </div>
      </div>

      <div>
        <p><strong>Current Cup Size:</strong> {currentCup || 'N/A'}</p>
        <p><strong>Target Cup Size:</strong> {targetCup || 'N/A'}</p>
        <p><strong>Breast Lift:</strong> {lift ? 'Yes' : 'No'}</p>
        <p><strong>Implant Shape:</strong> {implantShape || 'N/A'}</p>
      </div>

      <div style={{ marginTop: '2rem' }}>
        <button onClick={() => navigate('/')} style={{ marginRight: '1rem' }}>
          Back to Start
        </button>
        <button>
          Download as PDF
        </button>
      </div>
    </div>
  );
}